module.exports = __webpack_public_path__ + "static/a2-04e86d17d9838c7793ae9be22d617ac6.png";